export const breakPoints = {
  mobileLandscape: 'only screen and (min-width: 480px)',
  tabletPortrait: 'only screen and (min-width: 600px)',
  tabletLandscape: 'only screen and (min-width: 800px)',
  desktopSmall: 'only screen and (min-width: 1224px)',
  desktopLarge: 'only screen and (min-width: 1600px)',
  desktopXLarge: 'only screen and (min-width: 2160px)',
};
